import {UPDATE_NEWS_START} from "../../types";

export const update_news = (payload) => ({
    type: UPDATE_NEWS_START,
    payload,
});
